import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-choose',
  templateUrl: './why-choose.component.html',
  styleUrls: ['./why-choose.component.scss']
})

export class WhyChooseComponent implements OnInit {
  cards = [
    {
      icon: 'assets/images/fun-facts/01.svg',
      prefix: '+',
      number: '10',
      suffix: 'mil',
      text: 'Estudantes matriculados em todo o Brasil.',
    },
    {
      icon: 'assets/images/fun-facts/01.svg',
      prefix: '',
      number: '90',
      suffix: '%',
      text: 'De estudantes empregados.',
    },
    {
      icon: 'assets/images/fun-facts/02.svg',
      prefix: '+',
      number: '5',
      suffix: '',
      text: 'Cursos avaliados com nota máxima no MEC.',
    },
    {
      icon: 'assets/images/fun-facts/04.svg',
      prefix: '+',
      number: '5',
      suffix: 'mil',
      text: 'Cursos com formação compatível com perfis profissionais demandados em todo o Brasil.',
    },
  ];
  
  constructor() { }

  ngOnInit(): void {
  }
}
